import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	inputVariableChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[300]),
		borderRadius: theme.spacing(1),
		color: colors.gray[0],
		fontWeight: "bold"
	},
	tableActionButton: {
		borderRadius: 3,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50])
	}
}))

export default useStyles
